"use client";
import { ComingSoonProvider } from "@/contexts/ComingSoonContext";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import ComplianceSection from "@/components/ComplianceSection";
import DifferentiationSection from "@/components/DifferentiationSection";
import RestorationSection from "@/components/RestorationSection";
import PricingSection from "@/components/PricingSection";
import FaqSection from "@/components/FaqSection";
import CtaSection from "@/components/CtaSection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <ComingSoonProvider>
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <ComplianceSection />
        <DifferentiationSection />
        <RestorationSection />
        <PricingSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
    </ComingSoonProvider>
  );
};

export default Index;
